module.exports = __webpack_public_path__ + "static/img/icons_request_blue.ae9b846.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/icons_request_blue.svg
// module id = N3BV
// module chunks = 1